import { Skeleton as ChordsSkeleton } from '~/chords/Skeleton';
import { withClassNameHoc } from '~/components/WithClassNameHoc';

export const Skeleton = withClassNameHoc(ChordsSkeleton);
